import { useFormContext } from 'react-hook-form';
import React from 'react';
// Types
import {
  GetCampaignOffers_getCampaignOffers_entities_deliverablesV2,
  GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items_CbDeliverableFilesItemV2,
} from 'api/campaignV2/types/GetCampaignOffers';
import { CbDeliverableItemV2Status } from 'api/graphql-global-types';
// Helpers
import { getDateLabelFromDeliverable } from 'helpers/deliverables';
import { AWS_MEDIACONVERT_VIDEO_FORMATS } from 'helpers/videoFormats';
// UI
import { Typography } from 'antd';
// Components
import DropdownItem from '../DropdownItem/DropdownItem';
import UploadTimelineFilesInput from '../UploadTimelineFilesInput/UploadTimelineFilesInput';
// Styles
import styles from '../SubmitContent/SubmitContent.module.scss';

const { Text } = Typography;

type SubmitFinalContentProps = {
  item: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items_CbDeliverableFilesItemV2;
  deliverable?: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2 | null;
  formIndex: number;
};

const SubmitFinalContent: React.FC<SubmitFinalContentProps> = ({
  item,
  deliverable,
  formIndex,
}) => {
  const methods = useFormContext();
  const title = item.task?.title ?? 'Final Edited Video';
  const isApproved = item.status === CbDeliverableItemV2Status.APPROVED;
  const isRejected = item.status === CbDeliverableItemV2Status.REJECTED;

  const filesUploaded =
    methods.getValues(`finalContent.${formIndex}.files`)?.length > 0;

  return (
    <div className={styles.root}>
      <div className={styles.titleContainer}>
        <div className={styles.title}>
          <Text>{title}</Text>
          {isRejected && (
            <span className={styles.rejected}>Changes Needed</span>
          )}
        </div>
        {isApproved ? (
          <span className={styles.approved}>Approved</span>
        ) : (
          <span className={filesUploaded ? styles.approved : styles.disabled}>
            File {filesUploaded ? '✓' : '✗'}
          </span>
        )}
      </div>
      {isApproved ? (
        <div className={styles.tags}>
          {item.files?.map((file) => (
            <a
              key={file.key}
              href={file.url || undefined}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.tag}
            >
              {file.name || file.key}
            </a>
          ))}
        </div>
      ) : (
        <>
          <div className={styles.stats}>
            <div className={styles.statContent}>
              <div className={styles.statItem}>
                <Text>Content Due Date:</Text>
              </div>
              <Text>
                {getDateLabelFromDeliverable(
                  'content',
                  deliverable as
                    | GetCampaignOffers_getCampaignOffers_entities_deliverablesV2
                    | undefined
                )}
              </Text>
            </div>
            <div className={styles.divider} />
            <div className={styles.statContent}>
              <div className={styles.statItem}>
                <Text>Content Type:</Text>
              </div>
              <Text>Video</Text>
            </div>
          </div>
          <DropdownItem
            label="Description"
            labelClassName={styles.descriptionLabel}
            className={styles.descriptionContainer}
            defaultExpanded
          >
            {item.task?.description}
          </DropdownItem>
          <input
            type="hidden"
            name={`finalContent.${formIndex}.deliverableItemId`}
            ref={methods.register}
            value={item.id}
          />
          <UploadTimelineFilesInput
            fieldName={`finalContent.${formIndex}.files`}
            inputTitle={'Drop files here or click to upload'}
            inputDescription={'Support for images and videos up to 5gb'}
            tagIcon="video"
            acceptFileTypes={AWS_MEDIACONVERT_VIDEO_FORMATS}
          />
        </>
      )}
    </div>
  );
};

export default SubmitFinalContent;
